import store from "@/store";
import root from "./assets/root";
import icon from "./assets/icon";
import pet from "./assets/pet";
import modal from "./assets/modal";
import battle from "./assets/battle";
// v2.0
import village from "./assets/village";
import { sleep } from "@js/utils";
// v2.0 end

// 注意 按分类填写 方便查找
const assets = {
  imgs: [
    // 主界面图片
    ...root.imgs,
    // 图标
    ...icon.imgs,
    // 怪兽图片
    ...pet.imgs,
    // modal
    ...modal.imgs,
    // 对战界面
    ...battle.imgs,
    // v2.0
    // 怪物乐园
    ...village.imgs,
    // v2.0 end
  ],
  fns: [
    // 多语言
    {
      name: "多语言",
      async fn() {
        // 获取完多语言
        let lang = await store.dispatch("upDateLanguage", langHash);
        await store.dispatch("upDateLangText", langHash[lang].lang_id);
      },
    },
    // 预先需要获取的用户数据
    {
      name: "用户数据",
      async fn() {
        await store.dispatch("userInfo/upDateUserInfo");
        await Promise.all([
          // 宠物列表
          store.dispatch("petInfo/upDatePackageList"),
          // 教学状态信息
          store.dispatch("guidance/upDateGuide"),
          // 任务列表
          // store.dispatch("taskInfo/upDateTaskList"),
        ]);
      },
    },
    // 乐园信息
    {
      name: "乐园数据",
      async fn() {
        await sleep(1000);
        await store.dispatch("village/upDateVillageInfo");
      },
    },
  ],
  sounds: [...root.sounds],
};

// 注意 按分类填写 方便查找

export default assets;
